import {ChangeDetectionStrategy, Component, ViewChild} from "@angular/core";
import {AutocompleteComponent} from "../autocomplete.component";

@Component({
	selector: 'cp-autocomplete-example',
	templateUrl: "./autocomplete.example.html",
	styleUrls: ['./autocomplete.example.scss'],
	changeDetection:ChangeDetectionStrategy.OnPush
})
export class AutocompleteExampleComponent {

	@ViewChild("autoComplete",{static:false}) autoComplete: AutocompleteComponent;

	public source = ["d", "a", "a", "a", "aa", "f", "ff", "a a", "d"];

	public filter(item: string, value: string) {
		return item.startsWith(value.toLowerCase());
	}

	public dataChange(data){
	}
}
